/* 3OS R2A-R2 Homepage — cinematic runtime, faithful to the locked concept
   main.js, adapted for Shopify: asset URLs come from a JSON island, the loader
   is Theme-Editor / mode / reduced-motion aware with guaranteed cleanup, and the
   two champion CTAs perform real add-to-cart with full states. Namespaced,
   idempotent, safe under shopify:section:load. No dependency, no CDN. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 700px)');
  var ROUTES = window.routes || {};

  function scrollVertical(target, block) {
    if (!target) return;
    if (typeof window.tosVerticalScroll === 'function') {
      window.tosVerticalScroll(target, { block: block || 'start' });
      return;
    }
    var r = target.getBoundingClientRect();
    var header = document.querySelector('[data-r2-header], [data-tos-header]');
    var hh = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    var y = (window.scrollY || window.pageYOffset || 0) + r.top - hh;
    if (block === 'center' && r.height <= vh - hh) y -= ((vh - hh - r.height) / 2);
    document.documentElement.scrollLeft = 0; document.body.scrollLeft = 0;
    var old = document.documentElement.style.getPropertyValue('scroll-behavior');
    var priority = document.documentElement.style.getPropertyPriority('scroll-behavior');
    document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(0, Math.max(0, Math.round(y)));
    window.requestAnimationFrame(function () { if (old) document.documentElement.style.setProperty('scroll-behavior', old, priority); else document.documentElement.style.removeProperty('scroll-behavior'); });
  }

  var lock = window.tosR2Lock;
  if (!lock) {
    lock = window.tosR2Lock = (function () {
      var t = {}; function a() { document.body.classList.toggle('tos-r2-locked', Object.keys(t).length > 0); }
      return { add: function (k) { t[k] = 1; a(); }, remove: function (k) { delete t[k]; a(); } };
    })();
  }

  function cinemaMap(root) {
    var el = $('[data-r2-cinema]', root);
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function publishR2Ready() {
    document.documentElement.dataset.r2Ready = 'true';
    try { document.dispatchEvent(new CustomEvent('tos:r2:ready')); } catch (e) {}
  }

  /* ===== Signature handoff (golden olive: loader iris -> hero serve mark) ==== */
  function setupHandoff(root) {
    var anchor = $('[data-handoff-anchor]', root);
    var scene = $('.scene--tennis', root);
    var supported = Boolean(anchor && scene);
    var played = false;
    return {
      play: function (loader) {
        if (played) return; played = true;
        if (!supported || reduced.matches) return;
        var iris = $('.club-intro__iris', loader) || loader, from, to;
        try {
          var ir = iris.getBoundingClientRect(), ar = anchor.getBoundingClientRect();
          if (!ir.width || !ar.width) return;
          from = { x: ir.left + ir.width / 2, y: ir.top + ir.height / 2 };
          to = { x: ar.left + ar.width / 2, y: ar.top + ar.height / 2 };
        } catch (e) { return; }
        var w = 16, h = 21;
        var olive = document.createElement('span');
        olive.className = 'tos-handoff'; olive.setAttribute('aria-hidden', 'true');
        olive.style.left = (from.x - w / 2) + 'px'; olive.style.top = (from.y - h / 2) + 'px';
        olive.style.willChange = 'transform, opacity';
        document.body.appendChild(olive);
        var dx = to.x - from.x, dy = to.y - from.y, travel = 720;
        requestAnimationFrame(function () {
          olive.style.transition = 'opacity 180ms ease'; olive.style.opacity = '1';
          requestAnimationFrame(function () {
            olive.style.transition = 'transform ' + travel + 'ms cubic-bezier(0.2,0,0,1), opacity 200ms ease';
            olive.style.transform = 'translate(' + dx + 'px,' + dy + 'px) rotate(20deg) scale(0.78)';
          });
        });
        var settled = false;
        function settle() {
          if (settled) return; settled = true;
          scene.classList.add('is-served');
          olive.style.transition = 'opacity 200ms ease'; olive.style.opacity = '0';
          window.setTimeout(function () { olive.style.removeProperty('will-change'); if (olive.parentNode) olive.remove(); }, 220);
        }
        olive.addEventListener('transitionend', function (e) { if (e.propertyName === 'transform') settle(); });
        window.setTimeout(settle, travel + 180);
      }
    };
  }

  /* ===== Golden Rally loader — modes + skip + reduced-motion + hard timeout == */
  function setupLoader(root) {
    var loader = $('[data-loader]', root);
    if (!loader) { publishR2Ready(); return; }
    if (loader.dataset.r2Init) return;
    var home = $('[data-tos-r2-home]', document) || root;
    var mode = (home && home.dataset.loaderMode) || 'every_hard_load';
    var intro = new URLSearchParams(window.location.search).get('intro');
    var forceFull = intro === '1';   // ?intro=1 = full experience, always
    // RC-02: reduced-motion (without ?intro=1) shows the FULL Golden Rally
    // composition STATIC (~2200 ms) then cleans up. It never animates and is
    // never skipped on the default path.
    var staticIntro = reduced.matches && !forceFull;
    var hardTimer = null;

    function cleanup() {
      try { window.clearTimeout(hardTimer); } catch (e) {}
      try { if (loader.parentNode) loader.remove(); } catch (e) {}
      lock.remove('loader');
      /* Film arbitration is released only after the overlay is physically
         gone, so its MP4 cannot compete with the Golden Rally arrival. */
      publishR2Ready();
    }

    if (mode === 'off' || intro === '0') { cleanup(); return; }
    // every_hard_load (default) never checks sessionStorage; first_session is a
    // non-default option only — no `seen`/sessionStorage suppression by default.
    if (mode === 'first_session' && !forceFull) {
      try { if (sessionStorage.getItem('tos:r2:rally:v1')) { cleanup(); return; } sessionStorage.setItem('tos:r2:rally:v1', '1'); } catch (e) {}
    }
    loader.dataset.r2Init = '1';
    lock.add('loader');

    // 221A · the loader has no percentage counter and no phase readout any
    // more. The three phase words already exist on the gates as editable
    // settings, so the runtime reads them from the DOM instead of carrying its
    // own copy; `bar` is the only progress surface left.
    var bar = $('[data-loader-bar]', loader);
    var gateWord = function (sel, fallback) {
      var el = $(sel, loader); var t = el && el.textContent ? el.textContent.trim() : '';
      return t || fallback;
    };
    var PHASE = {
      serve: gateWord('.club-intro__gate--serve span', 'Servește'),
      character: gateWord('.club-intro__gate--character span', 'Caracter'),
      gather: gateWord('.club-intro__gate--gather span', 'La gătit')
    };
    var artwork = $('[data-loader-art] img', loader);
    var skip = $('[data-loader-skip]', loader);
    var duration = 3200, started = 0, finished = false;
    var handoff = setupHandoff(root);
    hardTimer = window.setTimeout(finish, 5200); // guaranteed cleanup — never leave page blank/locked

    function setPhase(l) { if (l) loader.dataset.loaderPhase = l; }
    function finish() {
      if (finished) return; finished = true;
      window.clearTimeout(hardTimer);
      loader.dataset.loaderState = 'complete';
      try { handoff.play(loader); } catch (e) {}
      loader.classList.add('is-hidden');
      window.setTimeout(cleanup, 720);
    }
    function tick(now) {
      if (finished) return;
      if (!started) started = now;
      var raw = Math.min((now - started) / duration, 1);
      var eased = 1 - Math.pow(1 - raw, 3);
      if (bar) bar.style.transform = 'scaleX(' + eased + ')';
      if (raw >= 0.25 && !loader.classList.contains('is-character')) { loader.classList.add('is-character'); setPhase(PHASE.character); }
      if (raw >= 0.48 && !loader.classList.contains('is-gather')) { loader.classList.add('is-gather'); setPhase(PHASE.gather); }
      if (raw >= 0.64 && !loader.classList.contains('is-converging')) { loader.classList.add('is-converging'); }
      if (raw >= 0.84 && !loader.classList.contains('is-arrived')) { loader.classList.add('is-arrived'); }
      if (raw < 1) { requestAnimationFrame(tick); return; }
      finish();
    }
    function start() {
      if (finished || loader.classList.contains('is-running')) return;
      loader.classList.add('is-running'); loader.dataset.loaderState = 'serve'; setPhase(PHASE.serve);
      requestAnimationFrame(tick);
    }
    // Reduced-static: full composition, no animation, ~2200 ms, then cleanup.
    function showStaticIntro() {
      if (loader.classList.contains('is-reduced')) return;
      loader.classList.add('is-reduced', 'is-running', 'is-character', 'is-gather', 'is-converging', 'is-arrived');
      loader.dataset.loaderState = 'reduced';
      if (bar) bar.style.transform = 'scaleX(1)';
      setPhase(PHASE.gather);
      window.setTimeout(cleanup, 2200);
    }
    var begin = staticIntro ? showStaticIntro : start;
    if (skip) skip.addEventListener('click', function () { if (staticIntro) cleanup(); else finish(); });
    if (artwork && artwork.complete) begin();
    else if (artwork) { artwork.addEventListener('load', begin, { once: true }); artwork.addEventListener('error', begin, { once: true }); window.setTimeout(begin, 900); }
    else window.setTimeout(begin, 60);
  }

  /* ===== Cinema loops (lazy video, offscreen pause, motion toggle) ========== */
  function setupCinema(root) {
    window.__tosFilm = '278-intent';
    var films = $$('[data-cinema-loop]', root);
    if (!films.length) return;
    var assets = cinemaMap(root);
    var home = $('[data-tos-r2-home]', document) || root;
    var motionEnabled = !home || home.dataset.motionEnabled !== 'false';
    var toggle = $('[data-motion-toggle]', root);
    var toggleLabel = toggle ? $('[data-motion-label]', toggle) : null;
    var playLabel = 'Pornește filmele', pauseLabel = 'Oprește filmele';
    var overrideKey = '3os-motion-override';
    var manualPaused = false;
    var reducedOverride = false;
    function rememberOverride(enabled) {
      try {
        if (enabled) window.localStorage.setItem(overrideKey, 'true');
        else window.localStorage.removeItem(overrideKey);
      } catch (e) {}
    }
    try { reducedOverride = reduced.matches && window.localStorage.getItem(overrideKey) === 'true'; } catch (e) {}
    if (reduced.matches && /(?:^|[?&])motion=1(?:&|$)/.test(window.location.search)) {
      reducedOverride = true;
      rememberOverride(true);
    }
    var systemPaused = function () { return reduced.matches && !reducedOverride; };
    var off = function () { return !motionEnabled || systemPaused(); };
    var activeFilm = null;
    var visibleFilms = new Map();
    var recoveryAttempts = new WeakMap();
    var attemptIds = new WeakMap();
    var failedAttemptIds = new WeakMap();
    var fallbackTimers = new WeakMap();
    var loadGeneration = 0;
    var arbitrationFrame = 0;
    var forceNextArbitration = false;
    var explicitBeforeReady = false;
    var FILM_ERROR_BUDGET = 2;
    var SLOW_MS = 6000;

    function markReducedOverride(enabled) {
      reducedOverride = enabled;
      if (enabled) document.body.dataset.motionOverride = 'true';
      else delete document.body.dataset.motionOverride;
    }

    function near(film) { var r = film.getBoundingClientRect(); return r.bottom > -220 && r.top < window.innerHeight + 220; }
    function setState(film, st) { film.dataset.videoState = st; film.classList.toggle('is-playing', st === 'playing' || st === 'paused'); }
    function syncToggle() {
      if (!toggle) return;
      var paused = manualPaused || off();
      toggle.hidden = !reduced.matches;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.dataset.systemReduced = String(systemPaused());
      if (toggleLabel) toggleLabel.textContent = paused ? playLabel : pauseLabel;
    }
    function automaticFilmReady() {
      return explicitBeforeReady || (
        !$('[data-loader]', root)
        && document.documentElement.dataset.r2Ready === 'true'
      );
    }
    function cancelFallback(film) {
      var timer = fallbackTimers.get(film);
      if (timer !== undefined) window.clearTimeout(timer);
      fallbackTimers.delete(film);
    }
    function unload(film, state) {
      var v = $('.cinema__loop', film);
      if (!v) return;
      var hadSource = v.hasAttribute('src') || Boolean(v.dataset.activeSrc);
      cancelFallback(film);
      attemptIds.delete(film);
      failedAttemptIds.delete(film);
      v.pause();
      if (hadSource) {
        v.removeAttribute('src');
        v.preload = 'none';
        v.load();
        delete v.dataset.activeSrc;
      }
      setState(film, state || 'poster');
    }
    function failAttempt(film, attemptId, errorName) {
      var v = $('.cinema__loop', film);
      if (!v || film !== activeFilm || !v.getAttribute('src')) return false;
      if (attemptIds.get(film) !== attemptId || failedAttemptIds.get(film) === attemptId) return false;
      failedAttemptIds.set(film, attemptId);
      var failures = (recoveryAttempts.get(film) || 0) + 1;
      recoveryAttempts.set(film, failures);
      if (errorName) film.dataset.lastErr = errorName;
      if (failures >= FILM_ERROR_BUDGET) unload(film, 'poster');
      else setState(film, 'blocked');
      return true;
    }
    function completeAttempt(film, attemptId) {
      if (film !== activeFilm || attemptIds.get(film) !== attemptId) return false;
      cancelFallback(film);
      recoveryAttempts.set(film, 0);
      failedAttemptIds.delete(film);
      return true;
    }
    function stopOthers(film) {
      films.forEach(function (candidate) {
        if (candidate !== film) unload(candidate, 'offscreen');
      });
    }
    function sourceFor(film) {
      var a = assets[film.dataset.scene];
      if (!a) return null;
      var mode = mobile.matches ? 'mobile' : 'desktop';
      if (film.dataset.filmMic === '1' && a.mobile) mode = 'mobile';
      return { assets: a, src: a[mode] || a.desktop || a.mobile };
    }
    function loadPlay(film, force) {
      if (film !== activeFilm) return;
      var v = $('.cinema__loop', film), selected = sourceFor(film);
      if (!v || !selected || !selected.src || off()) { if (off()) unload(film); return; }
      if (manualPaused) { v.pause(); setState(film, v.dataset.activeSrc ? 'paused' : 'poster'); return; }
      if ((recoveryAttempts.get(film) || 0) >= FILM_ERROR_BUDGET) { unload(film, 'poster'); return; }
      stopOthers(film);
      var attemptId = attemptIds.get(film);
      if (force || v.dataset.activeSrc !== selected.src) {
        cancelFallback(film);
        var generation = ++loadGeneration;
        attemptId = generation;
        attemptIds.set(film, attemptId);
        failedAttemptIds.delete(film);
        setState(film, 'loading'); v.pause(); v.preload = 'none'; v.src = selected.src; v.dataset.activeSrc = selected.src;
        v.autoplay = true; v.defaultMuted = true; v.muted = true; v.loop = true; v.playsInline = true; v.controls = false;
        v.setAttribute('autoplay', ''); v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.load();
        var fallbackTimer = window.setTimeout(function () {
          fallbackTimers.delete(film);
          if (
            generation !== loadGeneration
            || film !== activeFilm
            || attemptIds.get(film) !== generation
            || (recoveryAttempts.get(film) || 0) >= FILM_ERROR_BUDGET
            || !v.getAttribute('src')
          ) return;
          /* O singură degradare controlată la fișierul mic; fără coadă și fără furtună de retry. */
          if (v.readyState < 2 && selected.assets.mobile && v.dataset.activeSrc !== selected.assets.mobile) {
            film.dataset.filmMic = '1';
            var fallbackAttemptId = ++loadGeneration;
            attemptIds.set(film, fallbackAttemptId);
            failedAttemptIds.delete(film);
            v.src = selected.assets.mobile; v.dataset.activeSrc = selected.assets.mobile; v.load();
            var fallbackPlay = v.play();
            if (fallbackPlay && fallbackPlay.then) fallbackPlay.then(function () {
              if (completeAttempt(film, fallbackAttemptId)) setState(film, manualPaused ? 'paused' : 'playing');
            }).catch(function (err) {
              failAttempt(film, fallbackAttemptId, (err && err.name) || 'PlayRejected');
            });
          }
        }, SLOW_MS);
        fallbackTimers.set(film, fallbackTimer);
      }
      var p = v.play();
      if (p && p.then) p.then(function () {
        if (film !== activeFilm) { unload(film, 'offscreen'); return; }
        if (!completeAttempt(film, attemptId)) return;
        setState(film, manualPaused ? 'paused' : 'playing');
        if (manualPaused) v.pause();
      }).catch(function (err) {
        failAttempt(film, attemptId, (err && err.name) || 'PlayRejected');
      });
    }
    function selectNearestVisible(force) {
      if (off() || manualPaused || document.hidden || !automaticFilmReady()) {
        films.forEach(function (film) { unload(film); });
        activeFilm = null;
        return;
      }
      var viewportCenter = window.innerHeight / 2;
      var candidates = films.filter(function (film) { return visibleFilms.get(film) || near(film); });
      candidates.sort(function (a, b) {
        var ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
        return Math.abs(ar.top + ar.height / 2 - viewportCenter) - Math.abs(br.top + br.height / 2 - viewportCenter);
      });
      var next = candidates[0] || null;
      if (!next) {
        if (activeFilm) unload(activeFilm, 'offscreen');
        activeFilm = null;
        return;
      }
      if (activeFilm !== next) {
        if (activeFilm) unload(activeFilm, 'offscreen');
        activeFilm = next;
        force = false;
      }
      loadPlay(activeFilm, Boolean(force));
    }
    function scheduleArbitration(force) {
      forceNextArbitration = forceNextArbitration || Boolean(force);
      if (arbitrationFrame) return;
      arbitrationFrame = window.requestAnimationFrame(function () {
        arbitrationFrame = 0;
        var runForced = forceNextArbitration;
        forceNextArbitration = false;
        selectNearestVisible(runForced);
      });
    }

    films.forEach(function (film) {
      recoveryAttempts.set(film, 0);
      var v = $('.cinema__loop', film); if (!v) return;
      v.preload = 'none';
      v.addEventListener('playing', function () {
        var attemptId = attemptIds.get(film);
        if (completeAttempt(film, attemptId)) setState(film, 'playing');
      });
      v.addEventListener('waiting', function () { if (film === activeFilm) setState(film, 'loading'); });
      v.addEventListener('error', function () {
        if (film !== activeFilm || !v.getAttribute('src')) return;
        failAttempt(film, attemptIds.get(film), 'MediaError' + ((v.error && v.error.code) || ''));
      });
    });
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { visibleFilms.set(entry.target, entry.isIntersecting); });
      scheduleArbitration(false);
    }, { rootMargin: '60px 0px', threshold: 0.02 }) : null;
    films.forEach(function (film) {
      if (io) io.observe(film);
      else visibleFilms.set(film, near(film));
    });
    if (!io) scheduleArbitration(false);

    function retryActiveFilm() {
      if (!activeFilm || off() || manualPaused || document.hidden) return;
      var attempts = recoveryAttempts.get(activeFilm) || 0;
      if (attempts >= FILM_ERROR_BUDGET || activeFilm.dataset.videoState === 'playing') return;
      loadPlay(activeFilm, true);
    }
    window.addEventListener('pointerdown', retryActiveFilm, { passive: true });
    window.addEventListener('keydown', retryActiveFilm);

    /* 232 · diagnostic pe viu: ?filme=debug afișează starea reală a fiecărui
       film pe device-ul vizitatorului (pentru depanare cu fondatorii). */
    if (/[?&]filme=debug/.test(window.location.search)) {
      var dbg = document.createElement('div');
      dbg.setAttribute('style', 'position:fixed;left:8px;bottom:8px;z-index:9999;background:rgba(10,30,24,.94);color:#ffe;padding:10px 12px;font:11px/1.5 monospace;border-radius:8px;max-width:92vw;max-height:45vh;overflow:auto;white-space:pre;pointer-events:none');
      document.body.appendChild(dbg);
      window.setInterval(function () {
        var conn = navigator.connection || {};
        var head = 'UA:' + navigator.userAgent.slice(0, 60) + '\nreduced:' + reduced.matches + ' saveData:' + (conn.saveData || false) + ' net:' + (conn.effectiveType || '?') + '\n';
        var rows = films.map(function (film) {
          var v = $('.cinema__loop', film);
          return (film.dataset.scene || '?') + ' st:' + (film.dataset.videoState || '-') +
            (v ? ' rs:' + v.readyState + ' ns:' + v.networkState + ' p:' + (v.paused ? 1 : 0) + ' t:' + v.currentTime.toFixed(1) + (v.error ? ' ERR:' + v.error.code : '') : ' (fara video)') +
            (film.dataset.lastErr ? ' rej:' + film.dataset.lastErr : '');
        });
        dbg.textContent = head + rows.join('\n');
      }, 1000);
    }

    function refresh() {
      if (!reduced.matches && reducedOverride) markReducedOverride(false);
      if (reduced.matches && !reducedOverride) {
        try { if (window.localStorage.getItem(overrideKey) === 'true') markReducedOverride(true); } catch (e) {}
      }
      syncToggle();
      films.forEach(function (film) { unload(film); });
      activeFilm = null;
      scheduleArbitration(true);
    }
    if (mobile.addEventListener) mobile.addEventListener('change', refresh);
    if (reduced.addEventListener) reduced.addEventListener('change', refresh);
    if (toggle) toggle.addEventListener('click', function () {
      if (reduced.matches) {
        if (systemPaused()) { markReducedOverride(true); rememberOverride(true); }
        else { markReducedOverride(false); rememberOverride(false); }
        manualPaused = false;
      } else manualPaused = !manualPaused;
      syncToggle();
      if (systemPaused() || manualPaused) {
        films.forEach(function (film) { unload(film); });
        activeFilm = null;
      } else {
        explicitBeforeReady = true;
        scheduleArbitration(false);
      }
    });
    document.addEventListener('tos:r2:ready', function () { scheduleArbitration(false); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        films.forEach(function (film) { unload(film); });
        activeFilm = null;
      } else scheduleArbitration(false);
    });
    markReducedOverride(reducedOverride);
    syncToggle();
  }

  /* ===== Scene reveal ====================================================== */
  function setupReveal(root) {
    var scenes = $$('.scene', root);
    if (!scenes.length) return;
    if (reduced.matches || !('IntersectionObserver' in window)) { scenes.forEach(function (s) { s.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (!en.isIntersecting) return; en.target.classList.add('is-visible'); io.unobserve(en.target); });
    }, { rootMargin: '0px 0px -5%', threshold: 0.01 });
    scenes.forEach(function (s) { io.observe(s); });
  }

  /* ===== Product parallax (champions) ===================================== */
  function setupParallax(root) {
    var stage = $('.scene--champions', root), duo = $('[data-bottle-duo]', root);
    if (!stage || !duo || reduced.matches || !window.matchMedia('(hover: hover)').matches) return;
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
      var y = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
      duo.style.setProperty('--px', x.toFixed(3)); duo.style.setProperty('--py', y.toFixed(3));
    }, { passive: true });
    stage.addEventListener('pointerleave', function () { duo.style.setProperty('--px', '0'); duo.style.setProperty('--py', '0'); });
  }

  /* ===== Proof opener (scene 04 -> #dovada) =============================== */
  function setupProof(root) {
    var proof = $('[data-proof]', root), opener = $('[data-r2-proof-open]', root);
    if (!proof || !opener) return;
    opener.addEventListener('click', function (e) {
      e.preventDefault(); proof.open = true;
      scrollVertical(proof.closest('.lot-register') || proof, 'start');
      window.setTimeout(function () { var sm = $('summary', proof); if (sm) sm.focus({ preventScroll: true }); }, reduced.matches ? 0 : 420);
    });
  }

  /* ===== Club Programme dialog =========================================== */
  function setupClub(root) {
    var dialog = $('[data-club-programme]', root);
    if (!dialog || dialog.dataset.r2Init) return; dialog.dataset.r2Init = '1';
    var scroll = $('[data-club-scroll]', dialog), returnTo = null;
    function open(e, src) {
      if (e) e.preventDefault(); returnTo = src || null;
      if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute('open', '');
      lock.add('club');
      if (scroll) { scroll.scrollTop = 0; window.setTimeout(function () { scroll.focus({ preventScroll: true }); }, reduced.matches ? 0 : 60); }
    }
    function close() { if (dialog.open) dialog.close(); else dialog.removeAttribute('open'); }
    $$('[data-r2-club-open]', root).forEach(function (b) { b.addEventListener('click', function (e) { open(e, b); }); });
    $$('[data-club-close]', dialog).forEach(function (c) { c.addEventListener('click', close); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () { lock.remove('club'); if (returnTo && returnTo.focus) returnTo.focus({ preventScroll: true }); returnTo = null; });
  }

  /* ===== Commerce — real add-to-cart with full states ==================== */
  function setupCommerce(root) {
    var forms = $$('[data-r2-add-form]', root);
    if (!forms.length) return;
    var labelsEl = $('[data-r2-commerce]', root); var labels = {};
    if (labelsEl) { try { labels = JSON.parse(labelsEl.textContent) || {}; } catch (e) {} }
    var status = $('[data-r2-cart-status]', root);
    function announce(msg) { if (status) status.textContent = msg; }
    function drawer() { return document.querySelector('cart-drawer'); }

    forms.forEach(function (form) {
      if (form.dataset.r2Init) return; form.dataset.r2Init = '1';
      var btn = form.querySelector('button[type="submit"]');
      var fmt = form.getAttribute('data-r2-format');
      var card = form.closest('[data-format-card]');
      form.addEventListener('submit', function (e) {
        var id = form.querySelector('[name="id"]');
        if (!id || !id.value) return; // no variant -> native (button is disabled anyway)
        e.preventDefault();
        if (btn && btn.disabled) return;
        add(form, btn, fmt, card);
      });
    });

    function selectCard(card) {
      $$('[data-format-card]', root).forEach(function (c) {
        var sel = c === card; c.classList.toggle('is-selected', sel);
        var hit = $('.champion__hit', c); if (hit) hit.setAttribute('aria-pressed', String(sel));
        var st = $('[data-format-state]', c); if (st) st.hidden = !sel;
      });
    }

    function add(form, btn, fmt, card) {
      var fd = new FormData(form);
      var cd = drawer();
      if (cd && typeof cd.getSectionsToRender === 'function') {
        fd.append('sections', cd.getSectionsToRender().map(function (x) { return x.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      announce(labels.loading || 'Se adaugă…');
      var queue = window.__THREE_OLIVES_CART_TRANSACTIONS__;
      if (!queue || typeof queue.enqueue !== 'function') {
        announce(labels.error || 'Coșul nu este încă pregătit. Reîncearcă.');
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        return;
      }
      var variantId = String(fd.get('id') || '');
      queue.enqueue(function () {
        return fetch(ROUTES.cart_add_url || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || res.body.status) {
            var failure = new Error((res.body && (res.body.description || res.body.message)) || 'cart_add_failed');
            failure.addResponse = res;
            throw failure;
          }
          return fetch((ROUTES.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
            .then(function (cartResponse) {
              if (!cartResponse.ok) throw new Error('cart_confirmation_failed');
              return cartResponse.json();
            })
            .then(function (confirmedCart) { return { addResponse: res, confirmedCart: confirmedCart }; });
        });
      }, { action: 'add', variantId: variantId, quantity: 1, source: 'r2-home' })
        .then(function (res) {
          var addResponse = res.addResponse;
          selectCard(card);
          announce((fmt === '1000' ? labels.success1l : labels.success500) || 'Adăugat în coș.');
          document.dispatchEvent(new CustomEvent('tos:r2:cart:update')); /* 236: contorul din header ÎNAINTE de drawer (o excepție în drawer nu mai ascunde adăugarea) */
          var cd = drawer();
          if (cd) { cd.classList.remove('is-empty'); if (addResponse.body.sections && typeof cd.renderContents === 'function') { try { cd.renderContents(addResponse.body); } catch (e) {} } if (typeof cd.open === 'function') { try { cd.open(btn); } catch (e) {} } }
        })
        .catch(function (error) {
          var detail = String(error && error.message || '');
          var message = labels.error || 'Nu am putut confirma coșul. Verifică Bonul casei și reîncearcă.';
          if (/sold\s*out|epuizat|stock|available/i.test(detail)) {
            message = labels.soldout || 'Stoc epuizat.';
            if (card) { var st = $('[data-format-state]', card); if (st) { st.hidden = false; st.textContent = message; } }
          }
          announce(message);
          document.dispatchEvent(new CustomEvent('tos:r2:cart:update'));
        })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
    }
  }

  /* ===== Init (idempotent, section-reload safe) ========================== */
  function init(root) {
    root = root || document;
    var home = $('[data-tos-r2-home]', root) || (root.matches && root.matches('[data-tos-r2-home]') ? root : null) || document;
    try { setupLoader(home); } catch (e) {}
    /* 282: shared direct-film owner. */ setupReveal(home); setupParallax(home); setupProof(home); setupClub(home); setupCommerce(home);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme Editor: re-init when the homepage section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-tos-r2-home]')) init(e.target);
  });
  document.addEventListener('shopify:section:unload', function () { lock.remove('loader'); lock.remove('club'); });
})();
